module.exports = __webpack_public_path__ + "img/5-cancel.60621e6b.jpg";